import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-11 min-h-11 w-full min-w-0 rounded-none border-0 border-b border-[var(--rule-strong)] bg-transparent px-3 py-2 font-mono text-[14px] text-[var(--ink-1)] transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[var(--ink-3)] hover:border-[var(--ink-1)] focus-visible:border-b-2 focus-visible:border-[var(--signal)] focus-visible:bg-[var(--ground-sunk)] focus-visible:outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-dashed disabled:bg-transparent disabled:text-[var(--ink-3)] disabled:opacity-100 aria-invalid:border-b-2 aria-invalid:border-[var(--down)]",
        className
      )}
      {...props}
    />
  )
}

export { Input }
